import React from 'react'

interface BuyBuyBabyStoreProps {
  className?: string
  rounded?: boolean
}

const BuyBuyBabyStore: React.FC<BuyBuyBabyStoreProps> = ({
  className,
  rounded = true,
}: BuyBuyBabyStoreProps) => (
  <svg
    className={className}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    {rounded ? (
      <rect fill="#00A39B" height="24" rx="12" width="24" />
    ) : (
      <rect fill="#00A39B" height="24" width="24" />
    )}
    <path
      clipRule="evenodd"
      d="M11.7799 13.8939C11.7799 13.4742 11.7799 13.0545 11.7799 12.6306C11.8004 12.0751 11.8992 11.4867 12.2448 11.03C12.5041 10.6843 12.9155 10.4786 13.3394 10.4292C13.8208 10.3716 14.3475 10.4292 14.7466 10.7214C15.2075 11.0547 15.442 11.6102 15.5655 12.1451C15.7218 12.8652 15.7424 13.61 15.6889 14.3424C15.6272 14.9884 15.4873 15.655 15.1005 16.1899C14.8577 16.5315 14.4833 16.7866 14.0677 16.8606C13.5616 16.9471 13.0061 16.873 12.5905 16.5562C12.1708 16.2434 11.9362 15.7332 11.8457 15.2271C11.7593 14.7868 11.7881 14.3342 11.784 13.8898L11.7799 13.8939ZM18.0508 17.1816C18.4746 16.2722 18.6598 15.2682 18.7256 14.2683C18.7874 13.2643 18.7503 12.2397 18.5158 11.2604C18.3635 10.6144 17.8615 9.51162 17.4501 8.99316C16.9645 8.37594 16.2979 7.89451 15.5326 7.70111C14.6849 7.49126 13.7509 7.53652 12.969 7.93977C12.4917 8.17843 12.072 8.55288 11.8457 9.04254C11.8457 7.75049 11.8457 6.45845 11.8457 5.1664C11.8334 4.8866 11.8457 4.59445 11.7305 4.33521C11.6523 4.15005 11.4301 4.0801 11.2408 4.08833C10.8335 4.10067 10.4467 4.23646 10.0393 4.26115C9.26984 4.29818 8.51272 4.14593 7.75148 4.09244C7.41407 4.07598 7.06431 4.07598 6.73924 4.18297C6.51704 4.26115 6.30719 4.40105 6.19197 4.6109C6.01504 4.94009 5.99035 5.32688 6.00269 5.68898C6.02327 6.10046 6.20432 6.53663 6.57876 6.74237C6.89149 6.91107 7.2577 6.82878 7.58689 6.75471C7.8955 6.67653 8.22057 6.62715 8.53329 6.68476C8.6197 6.70533 8.71846 6.73414 8.76783 6.81643C8.83779 6.93165 8.84601 7.07567 8.85013 7.20734C8.85013 10.9724 8.85013 14.7374 8.85013 18.5025C8.85013 18.6876 8.86659 18.881 8.93654 19.0579C8.97357 19.169 9.05998 19.2596 9.17108 19.2966C9.40563 19.3748 9.65251 19.3871 9.8994 19.3954C10.3068 19.3954 10.7265 19.42 11.1215 19.3048C11.2573 19.2719 11.3602 19.1608 11.4013 19.0291C11.5124 18.7 11.4713 18.3461 11.4795 18.0046C11.8704 18.5642 12.4012 19.0415 13.039 19.309C13.6603 19.5764 14.3516 19.6258 15.0182 19.5558C15.6807 19.4818 16.3226 19.2184 16.8369 18.7946C17.3636 18.3625 17.7587 17.7947 18.0467 17.1816H18.0508Z"
      fill="white"
      fillRule="evenodd"
    />
  </svg>
)

export default BuyBuyBabyStore
